import gql from 'graphql-tag';
import { DEAL_SHEET_CONFIGURATION_FRAGMENT } from './configurationFragment';

export const DELETE_DEAL_SHEET_CONFIGURATION = gql`
  mutation DeleteDealSheetConfig($input: DeleteDealSheetConfigurationInput!) {
    dealSheet {
      result: deleteConfiguration(input: $input) {
        error
        success
        entity {
          ...DealSheetConfig
        }
      }
    }
  }
  ${DEAL_SHEET_CONFIGURATION_FRAGMENT}
`;
